import type { PerformanceScores } from '@mission.io/mission-toolkit'
export type Category = {
	title: string,
	lookup: (?PerformanceScores) => ?number,
	id: string,
}

export const CATEGORIES: Category[] = [
	{
		title: 'Knowledge',
		id: 'questions',
		lookup: (score: ?PerformanceScores) => score?.knowledge.questions,
	},
	{
		title: 'Application',
		id: 'application',
		lookup: (score: ?PerformanceScores) => score?.knowledge.application,
	},
	{
		title: 'Initiative',
		id: 'initiative',
		lookup: (score: ?PerformanceScores) => score?.disposition.initiative,
	},
	{
		title: 'Collaboration',
		id: 'collaboration',
		lookup: (score: ?PerformanceScores) => score?.skills.collaboration,
	},
	{
		title: 'Critical Thinking',
		id: 'criticalThinking',
		lookup: (score: ?PerformanceScores) => score?.skills.criticalThinking,
	},
	{
		title: 'Resilience',
		id: 'grit',
		lookup: (score: ?PerformanceScores) => score?.disposition.grit,
	},
]

export const PROPORTION_COLORS = [
	{ color: '#ff6f1e', proportion: -Infinity },
	{ color: '#FEE75C', proportion: 0.5 },
	{ color: '#98eb43', proportion: 0.8 },
	{ color: '#38f9ff', proportion: 0.95, isGlowing: true },
]

export const MAX_PREVIOUS_MISSIONS_TO_SHOW = 1
